import React, { useState } from "react";
import styled from "styled-components";
import Modal from "../../../../components/Modal";
import { Typography, IconButton } from "@mui/material";
import Icon from "../../../../components/Icon";
import { IMAGE_MIME } from "../../../../constant";

const PreviewContainer = styled.div`
  border: 1px dashed #cacaca;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 4px;
  position: relative;
  height: 300px;
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MainContainer = styled.div`
  padding-bottom: 40px;
  min-height: 100px;
  width: 100%;
  .numberField {
    margin-top: 20px;
  }
  .responseContainer {
    margin-top: 12px;
    .listItem {
      display: flex;
      flex-direction: row;
      margin-left: 10px;
    }
  }
`;

const UploadFile = ({ onSubmit, onCancel, fileType, isLoading }) => {
  const [fileUrl, setFileUrl] = useState("");
  const [fileData, setFileData] = useState("");

  const isImageType = fileType === "image";

  const applicableMimeTypes = isImageType ? IMAGE_MIME : ["application/pdf"];

  return (
    <Modal
      onSubmit={() => onSubmit(fileData)}
      confirmTitle={"Upload"}
      cancelTitle={"Cancel"}
      onCancel={onCancel}
      isLoading={isLoading}
      isDisabled={!fileData || !fileUrl}
    >
      <MainContainer>
        <Typography
          variant="h6"
          textAlign={"center"}
          fontWeight={700}
          width={"100%"}
          marginBottom={2}
        >
          {"Upload File"}
        </Typography>
        <PreviewContainer>
          {fileUrl ? (
            <>
              {isImageType && (
                <img
                  src={fileUrl}
                  style={{
                    width: "100%",
                    objectFit: "contain",
                    height: "100%",
                    backgroundColor: "#F4F4F4",
                    cursor: "zoom-in",
                  }}
                  alt={"img"}
                  onLoad={() => {}}
                  onClick={() => {}}
                />
              )}
              {!isImageType && (
                <object
                  aria-label="pdf"
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  type="text/html"
                  data={fileUrl ?? ""}
                />
              )}
            </>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                id="selectNotifyImage"
                type="file"
                onChange={(e) => {
                  const file = e.target?.files[0];
                  if (!file) return;
                  if (!applicableMimeTypes.includes(file?.type)) {
                    alert("Invalid File. Please select an image.");
                    e.target.value = null;
                    return;
                  }
                  if (file) {
                    setFileData(file);
                    if (isImageType) {
                      const img = new Image();
                      img.src = window.URL.createObjectURL(file);
                      img.onload = () => {
                        setFileUrl(img.src);
                      };
                    }
                    {
                      const fileUrl = window.URL.createObjectURL(file);
                      setFileUrl(fileUrl);
                    }
                  }
                }}
                accept={applicableMimeTypes}
              />
              <Typography
                variant="caption"
                fontWeight={400}
                color={false ? "error" : "rgba(0, 0, 0, 0.6)"}
                style={{ marginLeft: 8, marginTop: 4 }}
              >
                {isImageType
                  ? "Select machine image to upload"
                  : "Select operator manual pdf to upload"}
              </Typography>
            </div>
          )}
          {fileUrl && (
            <IconButton
              style={{ position: "absolute", right: -10, top: -10 }}
              aria-label="close"
              size="medium"
              onClick={() => {
                setFileUrl("");
              }}
            >
              <Icon icon="circleClose" height={30} width={30} />
            </IconButton>
          )}
        </PreviewContainer>
      </MainContainer>
    </Modal>
  );
};

export default UploadFile;
